// @owners { team: patients-team }
import { useNavigationContext } from '~web/contexts';

const isOnboardingRoute = (pathname: string | null | undefined) => {
  // the first screen of the old onboarding flow is on /onboard/<temp_password>
  return Boolean(pathname?.startsWith('/onboard'));
};

const isOrganicOnboardingRoute = (pathname: string | null | undefined) => {
  return pathname === '/patient-onboarding';
};

export const useIsOnboardingRoute = () => {
  const { current, previous: previousPath } = useNavigationContext();
  const currentPath = current?.pathname;

  return {
    isOrganicOnboardingRoute: isOrganicOnboardingRoute(previousPath) || isOrganicOnboardingRoute(currentPath),
    isOnboardingRoute: isOnboardingRoute(previousPath) || isOnboardingRoute(currentPath),
  };
};
